import { createStore as reduxCreateStore } from "redux"
import { persistStore, persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage/session"

import { reducer } from "./reducers"
import { AmplifyBridge } from "./bridge"


const persistConfig = {
  key: "root",
  storage,
}


export const createStore = () => {
  const initialState = {
    user: null,
    customer: null,
    subscriptions: null,
    ownedProducts: null,
    awsCredentials: {},
    dismissedPopups: [],
    darkMode: {darkMode: true},
  }
  const persistedReducer = persistReducer(persistConfig, reducer)

  let store = reduxCreateStore(persistedReducer, initialState)

  let persistor = persistStore(store)

  new AmplifyBridge(store)
  return {store, persistor}
}

export default createStore
